<header>
  <app-registration-header title="Welcome to the CLEPA Registration Platform">
    
  </app-registration-header>
</header>

<main>
  <div class="container" style="margin-top: 100px;">
    <div class="row">
      <div style="display: flex; justify-content: center;">For event registration, please follow the link you have received in the invitation
      </div>
    </div>
  </div>
</main>
<footer>
    <app-footer leftFooterText="&copy; CLEPA 2026"></app-footer>
</footer>